export const MAX_RADIUS_RANGE = 205;
export const RADIUS_RANGE_STEPS = 50;

export const getNextRangeValue = (currentValue: number): number => currentValue + 50;

export const getDisplayRangeValue = (currentValue: number): number => currentValue + 50;

export const inviteDriverMessage = `Olá, gostaria de negociar com você através da Fretebras.\nLá você consegue encontrar mais fretes e ter mais segurança.\n\nBaixe o aplicativo pelo link:\nhttps://play.google.com/store/apps/details?id=br.lgfelicio`;
